module.exports = __webpack_public_path__ + "static/img/13-1.f6f7b30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/13-1.jpg
// module id = LT+D
// module chunks = 26